import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download, ClipboardList } from "lucide-react";
import { PageHero } from "../components/shared/Primitives";
import SEOHead from "../components/shared/SEOHead";
import { api } from "../lib/api";

export default function Shop() {
  const [products, setProducts] = useState(null); // null = loading

  useEffect(() => {
    let alive = true;
    api
      .get("/api/shop/products")
      .then(({ data }) => {
        if (alive) setProducts(data.products || []);
      })
      .catch(() => {
        if (alive) setProducts([]);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div data-testid="page-shop">
      <SEOHead
        title="JCC Shop"
        description="Practical downloads for carers and families — activity packs and useful tools to support everyday care."
        path="/shop"
      />
      <PageHero
        eyebrow="JCC Shop"
        title="Practical downloads for carers and families"
        description="Activity packs and useful tools to support everyday care."
        accent="teal"
      />
      <section className="section">
        <div className="container-jcc max-w-5xl">
          {products === null && (
            <div className="text-center text-ink-muted py-12" data-testid="shop-loading">
              Loading…
            </div>
          )}
          {products && products.length === 0 && (
            <div className="text-center text-ink-muted py-12" data-testid="shop-empty">
              New downloads are on their way — check back soon.
            </div>
          )}
          {products && products.length > 0 && (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="shop-product-grid">
              {products.map((p) => (
                <Link
                  key={p.slug}
                  to={`/shop/${p.slug}`}
                  className="group card-base p-6 flex flex-col hover:border-teal hover:-translate-y-0.5 transition-all duration-200"
                  data-testid={`shop-product-card-${p.slug}`}
                >
                  <div className="w-10 h-10 rounded-xl bg-teal/10 text-teal flex items-center justify-center">
                    {p.product_type === "service" ? <ClipboardList className="w-5 h-5" strokeWidth={1.75} /> : <Download className="w-5 h-5" strokeWidth={1.75} />}
                  </div>
                  <h3 className="mt-4 font-display font-semibold text-lg">{p.title}</h3>
                  <p className="mt-1 text-sm text-ink-muted">{p.subtitle}</p>
                  <p className="mt-3 text-sm text-ink-muted leading-relaxed flex-1 line-clamp-3">
                    {(p.description || [])[0]}
                  </p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="font-display font-bold text-teal text-lg">{p.price_display}</span>
                    {p.on_sale ? (
                      <span className="inline-flex items-center gap-1.5 text-teal font-semibold text-sm">
                        View <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                      </span>
                    ) : (
                      <span className="pill bg-slate-100 text-ink-muted">No longer available</span>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
